"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const api_1 = require("../../api");
const react_helmet_1 = __importDefault(require("react-helmet"));
const Badge_1 = __importDefault(require("../../components/Utils/Badge"));
const moment_1 = __importDefault(require("moment"));
const Button_1 = __importDefault(require("../../forms/Button"));
const errorNotification_1 = require("../../errorNotification");
const IsAllowed_1 = __importDefault(require("../../Auth/IsAllowed"));
const permissions_1 = require("../../types/permissions");
const List = ({ match }) => {
    const { path } = match;
    const [orders, setOrders] = (0, react_1.useState)([]);
    const ordersApi = new api_1.OrdersApi();
    const [activeOrder, setActiveOrder] = (0, react_1.useState)(true);
    const onDelete = async (id) => {
        if (confirm(`Möchten Sie diese Bestellung wirklich löschen: ID ${id}?`)) {
            try {
                const response = await ordersApi.delete(id);
                if (response.success === true) {
                    setOrders((orders) => orders.filter((o) => o.id !== id));
                    (0, errorNotification_1.notify)('success', 'deleted!');
                }
            }
            catch (error) {
                (0, errorNotification_1.notifyError)(error);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        const fetchItems = async () => {
            const { items, active_order } = await ordersApi.index();
            setOrders(items);
            setActiveOrder(active_order);
        };
        fetchItems();
    }, []);
    const resolveOrder = async (orderId) => {
        await ordersApi.resolve(orderId);
        window.location.reload();
    };
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Bestellungen")),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Bestellungen")),
            react_1.default.createElement(IsAllowed_1.default, { permissions: [permissions_1.OrdersPermissions.CREATE_ORDERS] }, activeOrder ? null : (react_1.default.createElement(react_router_dom_1.Link, { to: `${path}/add`, className: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" }, "Neue Bestellung"))),
            react_1.default.createElement("div", { className: "mt-4 flex md:mt-0 md:ml-4" })),
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" },
                react_1.default.createElement("div", { className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" },
                    react_1.default.createElement("div", { className: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" },
                        react_1.default.createElement("table", { className: "min-w-full divide-y divide-gray-200" },
                            react_1.default.createElement("thead", null,
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Nr."),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Name"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Bestelltermin"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50" },
                                        react_1.default.createElement("span", { className: "sr-only" })),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50" },
                                        react_1.default.createElement("span", { className: "sr-only" })))),
                            react_1.default.createElement("tbody", null, orders.map((order) => (react_1.default.createElement("tr", { key: order.id, className: "bg-white" },
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, order.id),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, order.name),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }, moment_1.default.utc(order.expires_at).local().format("DD.MM.YYYY, HH:mm")),
                                react_1.default.createElement("td", { className: "flex justify-end px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, !order.resolved ? (react_1.default.createElement("div", null,
                                    react_1.default.createElement(IsAllowed_1.default, { permissions: [permissions_1.OrdersPermissions.UPDATE_ORDERS] },
                                        react_1.default.createElement(Button_1.default, { className: 'ml-4' },
                                            react_1.default.createElement(react_router_dom_1.Link, { to: `${path}/${order.id}/edit` }, "Termin bearbeiten"))),
                                    react_1.default.createElement(IsAllowed_1.default, { permissions: [permissions_1.OrdersPermissions.DELETE_ORDERS] },
                                        react_1.default.createElement(Button_1.default, { className: 'ml-4', onClick: () => onDelete(order.id) }, "L\u00F6schen")),
                                    react_1.default.createElement(IsAllowed_1.default, { permissions: [permissions_1.OrdersPermissions.UPDATE_ORDERS] },
                                        react_1.default.createElement(Button_1.default, { className: 'ml-4', onClick: () => resolveOrder(order.id) }, "Abschlie\u00DFen")))) : react_1.default.createElement(Badge_1.default, { variant: 'red' }, "Abgeschlossen")),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" }, (!order.expired && !order.resolved) ? (react_1.default.createElement(IsAllowed_1.default, { permissions: [permissions_1.OrdersPermissions.MANAGE_ORDER_QUANTITIES] },
                                    react_1.default.createElement(react_router_dom_1.Link, { to: `${path}/${order.id}/requests` },
                                        react_1.default.createElement(Button_1.default, { className: 'ml-4' }, "Etiketten bestellen")))) : null))))))))))));
};
exports.default = List;
